"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { NonOpenableFilterChip } from "./variants/NonOpenableFilterChip.js";
import { OpenableFilterChip } from "./variants/OpenableFilterChip.js";
const FilterChip_FilterChip = /*#__PURE__*/ forwardRef(function(props, ref) {
    return props.opens ? /*#__PURE__*/ jsx(OpenableFilterChip, {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ jsx(NonOpenableFilterChip, {
        ...props,
        ref: ref
    });
});
export { FilterChip_FilterChip as FilterChip };
